module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "show": _vm.showNutritionModal,
      "effect": "fade"
    },
    on: {
      "closeOnEscape": _vm.closeModal
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_c('span', [_vm._v("×")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(!_vm.selectLocationMode) ? _c('h4', {
    key: "mainEditMode",
    staticClass: "modal-title center"
  }, [_vm._v("Item Nutrition Info")]) : _vm._e(), _vm._v(" "), (_vm.selectLocationMode) ? _c('h4', {
    key: "selectLocationMode",
    staticClass: "modal-title center"
  }, [_c('i', {
    staticClass: "fa fa-chevron-left clickable pull-left back-button",
    on: {
      "click": function($event) {
        _vm.closeSelectLocationsPopup()
      }
    }
  }), _vm._v("Select Stores")]) : _vm._e()])], 1), _vm._v(" "), (!_vm.creatingNutritionInfo) ? _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [(_vm.errorMessage.length) ? _c('div', {
    staticClass: "margin-top-20"
  }, [_c('div', {
    staticClass: "alert alert-danger"
  }, [_c('span', [_vm._v(_vm._s(_vm.errorMessage))]), _vm._v(" "), _c('div', {
    staticClass: "margin-top-15"
  }, [_c('button', {
    staticClass: "btn blue",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.creatingNutritionInfo = true
      }
    }
  }, [_vm._v("Add Nutrition Info")])])])]) : _vm._e(), _vm._v(" "), (!_vm.errorMessage.length && !_vm.selectLocationMode) ? _c('div', {
    staticClass: "portlet light bg-inverse clear"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_vm._v("Click on the button on the right to edit")]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('a', {
    staticClass: "btn btn-circle btn-icon-only btn-default",
    on: {
      "click": function($event) {
        _vm.editingNutritionInfo = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-pencil"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [(_vm.editNutritionError.length) ? _c('div', [_c('div', {
    staticClass: "alert alert-danger"
  }, [_c('span', [_vm._v(_vm._s(_vm.editNutritionError))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "table-scrollable table-fixed-height"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(" Category ")]), _vm._v(" "), _c('th', [_vm._v(" Value ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.itemNutritionInfo), function(info) {
    return _c('tr', [(info.key !== 'id' && info.key !== 'item_id') ? _c('td', [_vm._v(" " + _vm._s(info.name) + " ")]) : _vm._e(), _vm._v(" "), (info.key !== 'id' && info.key !== 'item_id') ? _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (info.value),
        expression: "info.value"
      }],
      staticClass: "form-control input-sm",
      attrs: {
        "type": "text",
        "disabled": !_vm.editingNutritionInfo
      },
      domProps: {
        "value": (info.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(info, "value", $event.target.value)
        }
      }
    })]) : _vm._e()])
  }))])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "margin-bottom-10 margin-top-30 margin-right-10"
  }, [_vm._v("Select locations to apply the changes to:")]), _vm._v(" "), _c('button', {
    staticClass: "btn blue btn-outline",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.selectLocations($event)
      }
    }
  }, [_vm._v("Select locations")]), _vm._v(" "), (_vm.selectedLocations.length) ? _c('p', {
    staticClass: "grey-label margin-top-10"
  }, [_vm._v("Selected " + _vm._s(_vm.selectedLocations.length) + " location"), (_vm.selectedLocations.length !== 1) ? _c('span', [_vm._v("s")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('label', [_vm._v("Update all items?")]), _c('br'), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-color": "#0c6",
      "inactive-color": "#ff4949",
      "active-value": 1,
      "inactive-value": 0,
      "active-text": "Yes",
      "inactive-text": "No"
    },
    model: {
      value: (_vm.update_all_items),
      callback: function($$v) {
        _vm.update_all_items = $$v
      },
      expression: "update_all_items"
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.selectLocationMode) ? _c('select-locations-popup', {
    attrs: {
      "previouslySelected": _vm.selectedLocations
    },
    on: {
      "closeSelectLocationsPopup": _vm.updateSelectedLocations
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.creatingNutritionInfo) ? _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "portlet light bg-inverse clear"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_vm._v("Add nutrition info for '" + _vm._s(_vm.item.name) + "'")])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [(_vm.createNutritionError.length) ? _c('div', {
    staticClass: "margin-top-20"
  }, [_c('div', {
    staticClass: "alert alert-danger"
  }, [_c('span', [_vm._v(_vm._s(_vm.createNutritionError))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "table-scrollable table-fixed-height"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(" Category ")]), _vm._v(" "), _c('th', [_vm._v(" Value ")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(" Calories ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newNutritionInfo.calories),
      expression: "newNutritionInfo.calories"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newNutritionInfo.calories)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newNutritionInfo, "calories", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" Minimum Calories ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newNutritionInfo.min_cal),
      expression: "newNutritionInfo.min_cal"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newNutritionInfo.min_cal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newNutritionInfo, "min_cal", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" Total Fat ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newNutritionInfo.total_fat),
      expression: "newNutritionInfo.total_fat"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newNutritionInfo.total_fat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newNutritionInfo, "total_fat", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" Saturated Fat ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newNutritionInfo.saturated_fat),
      expression: "newNutritionInfo.saturated_fat"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newNutritionInfo.saturated_fat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newNutritionInfo, "saturated_fat", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" Trans Fat ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newNutritionInfo.trans_fat),
      expression: "newNutritionInfo.trans_fat"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newNutritionInfo.trans_fat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newNutritionInfo, "trans_fat", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" Cholesterol ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newNutritionInfo.cholesterol),
      expression: "newNutritionInfo.cholesterol"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newNutritionInfo.cholesterol)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newNutritionInfo, "cholesterol", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" Sodium ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newNutritionInfo.sodium),
      expression: "newNutritionInfo.sodium"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newNutritionInfo.sodium)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newNutritionInfo, "sodium", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" Carbohydrates ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newNutritionInfo.carbs),
      expression: "newNutritionInfo.carbs"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newNutritionInfo.carbs)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newNutritionInfo, "carbs", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" Fibre ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newNutritionInfo.fibre),
      expression: "newNutritionInfo.fibre"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newNutritionInfo.fibre)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newNutritionInfo, "fibre", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" Sugar ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newNutritionInfo.sugar),
      expression: "newNutritionInfo.sugar"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newNutritionInfo.sugar)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newNutritionInfo, "sugar", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" Protein ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newNutritionInfo.protein),
      expression: "newNutritionInfo.protein"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newNutritionInfo.protein)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newNutritionInfo, "protein", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" Vitamin A ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newNutritionInfo.vit_a),
      expression: "newNutritionInfo.vit_a"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newNutritionInfo.vit_a)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newNutritionInfo, "vit_a", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" Vitamin C ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newNutritionInfo.vit_c),
      expression: "newNutritionInfo.vit_c"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newNutritionInfo.vit_c)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newNutritionInfo, "vit_c", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" Calcium ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newNutritionInfo.calcium),
      expression: "newNutritionInfo.calcium"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newNutritionInfo.calcium)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newNutritionInfo, "calcium", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" Iron ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newNutritionInfo.iron),
      expression: "newNutritionInfo.iron"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newNutritionInfo.iron)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newNutritionInfo, "iron", $event.target.value)
      }
    }
  })])])])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [(_vm.editingNutritionInfo && !_vm.creatingNutritionInfo && !_vm.selectLocationMode) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.updateItemNutritionInfo()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), (!_vm.editingNutritionInfo && _vm.creatingNutritionInfo && !_vm.selectLocationMode) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.createItemNutritionInfo()
      }
    }
  }, [_vm._v("Create")]) : _vm._e(), _vm._v(" "), (!_vm.editingNutritionInfo && !_vm.creatingNutritionInfo && !_vm.selectLocationMode) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Save")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ad18906"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/MenuManager/Items/NutritionInfo.vue
// module id = 745
// module chunks = 0